import { render, staticRenderFns } from "./adminComingSoon.vue?vue&type=template&id=b836fca4&scoped=true"
import script from "./adminComingSoon.vue?vue&type=script&lang=js"
export * from "./adminComingSoon.vue?vue&type=script&lang=js"
import style0 from "./adminComingSoon.vue?vue&type=style&index=0&id=b836fca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b836fca4",
  null
  
)

export default component.exports